import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { ApplicationHostTypeService, ReferenceDataConstants, ReferenceDataLabels } from 'rome-library';
import { UserCredentialStore } from '../../../interfaceTypes/sharedFeatures/registration/services/user-credential.store';
import { States } from '../../../shared';
import { TaggingService } from '../../../tag-manager';
import { SystemAvailabilityService } from '../../services/system-availability.service';
import { UserService } from '../../services/user.service';

@UntilDestroy()
@Component({
  selector: 'boi-forgotten-password',
  templateUrl: './forgotten-password.page.html'
})
export class ForgottenPasswordPage implements OnInit {
  public readonly referenceDataLabels = ReferenceDataLabels;
  public readonly referenceDataConstants = ReferenceDataConstants;
  public isEmailSent: boolean;
  public emailAddress: string;
  public shouldDisplayErrorMessage: boolean;
  public isResendPossible: boolean;
  public hasExceededMaximumOtpSendLimit: boolean;

  constructor(
    private readonly userService: UserService,
    private readonly router: Router,
    private readonly applicationHostTypeService: ApplicationHostTypeService,
    private readonly userCredentialStore: UserCredentialStore,
    private readonly systemAvailabilityService: SystemAvailabilityService,
    private readonly taggingService: TaggingService
  ) {}

  ngOnInit(): void {
    this.taggingService.resetDataLayer();
    this.taggingService.execute();

    this.emailAddress = this.userCredentialStore.getEmail();
    this.getApplicationSystemAvailability();
  }

  private getApplicationSystemAvailability(): void {
    this.systemAvailabilityService.getApplicationSystemAvailability().pipe(untilDestroyed(this)).subscribe();
  }

  public continue(form: NgForm): void {
    if (form.valid) {
      this.isEmailSent = false;
      this.userService
        .sendResetForgottenPasswordRequest(this.emailAddress)
        .pipe(untilDestroyed(this))
        .subscribe(
          (response) => {
            if (response.hasExceededMaximumOtpSendLimit) {
              this.hasExceededMaximumOtpSendLimit = response.hasExceededMaximumOtpSendLimit;
            } else {
              this.isResendPossible = response.resendPossible;
              this.isEmailSent = true;
              this.userCredentialStore.setEmail(undefined);
            }
          },
          () => {
            this.isEmailSent = false;
            this.isResendPossible = false;
            this.shouldDisplayErrorMessage = true;
          }
        );
    } else {
      form.control.markAllAsTouched();
    }
  }

  public goToLogin(): void {
    this.userCredentialStore.setEmail(undefined);
    void this.router.navigate([this.applicationHostTypeService.getCode(), States.Login]);
  }
}
